module.exports = __webpack_public_path__ + "static/img/simei.6f32896d.png";